// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legacy-styles {
  line-height: 1.42857143;
  color: #6a6c6f;
  background: white;
}
.legacy-styles .btn {
  font-size: 14px;
  line-height: 1.42857143;
}
.legacy-styles .btn-sm {
  font-size: 12px;
  line-height: 1.5;
}
.legacy-styles .abc-checkbox label::before {
  left: 2px;
}
.legacy-styles .abc-checkbox label::after {
  left: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/pos/css/legacy-styles.less"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX","sourcesContent":[".legacy-styles {\n  line-height: 1.42857143;\n  color: #6a6c6f;\n  background: white;\n}\n.legacy-styles .btn {\n  font-size: 14px;\n  line-height: 1.42857143;\n}\n.legacy-styles .btn-sm {\n  font-size: 12px;\n  line-height: 1.5;\n}\n.legacy-styles .abc-checkbox label::before {\n  left: 2px;\n}\n.legacy-styles .abc-checkbox label::after {\n  left: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
